export var DOLFO_CONFIGURATION = {
    MONTH_1: "Gennaio",
    MONTH_2: "Febbraio",
    MONTH_3: "Marzo",
    MONTH_4: "Aprile",
    MONTH_5: "Maggio",
    MONTH_6: "Giugno",
    MONTH_7: "Luglio",
    MONTH_8: "Agosto",
    MONTH_9: "Settembre",
    MONTH_10: "Ottobre",
    MONTH_11: "Novembre",
    MONTH_12: "Dicembre",
    NEXT: "Successivo",
    PREVIOUS: "Precedente",
    TODAY: "Oggi",
    WEEK_DAY_1: "Lunedì",
    WEEK_DAY_2: "Martedì",
    WEEK_DAY_3: "Mercoledì",
    WEEK_DAY_4: "Giovedì",
    WEEK_DAY_5: "Venerdì",
    WEEK_DAY_6: "Sabato",
    WEEK_DAY_7: "Domenica",
    HOURS: "Ore",
    MINUTES: "Minuti",
    SECONDS: "Secondi",
    MILLISECONDS: "Millisecondi",
    SELECT_FILE: "Seleziona file",
    PAGE: "Pagina",
    NO_RESULTS: "Nessun risultato",
    ADD: "Aggiungi",
    CLOSE: "Chiudi",
    ORDER: "Ordina",
    FIRST_PAGE: "Prima pagina",
    LAST_PAGE: "Ultima pagina",
    PAGES: "Pagine",
    NEW: "Nuovo",
    COLLAPSED: "Collassati",
    SELECT: "Seleziona",
    RESET: "Reimposta",
    SHOW: "Mostra",
    INCREASE: "Aumenta",
    DECREASE: "Riduci",
    FILTER: "Filtra",
    EXPAND: "Espandi",
    COLLAPSE: "Collassa",
    NO_MORE_STEPS: "Non ci sono altri passaggi",
    COMBOBOX_SEARCH: "Cerca",
    EXPORT: "Esporta",
    REQUIRED: "Obbligatorio",
    OK: "Ok",
    CANCEL: "Annulla"
};
/** Function to get the value of the language configuration
 * @param key The key to get
 * @returns The value of the variable based on the key (string)
 */
export var getConfigVar = function (key) {
    var findConfig = window.DOLFO_LANGUAGE_CONFIG;
    return (findConfig === null || findConfig === void 0 ? void 0 : findConfig[key]) || DOLFO_CONFIGURATION[key];
};
